import routes from '@modules/service/service-routes';
import store from '@modules/service/service-store';

export default {
  routes,
  store,
};
